import React from 'react';
import { flexClasses } from '../../../utils/proposalBoxAlign';
import styles from './ProposalBoxAlign.module.css';

/**
 * Conteneur flex — alignements horizontal / vertical (positions proposal).
 */
export default function ProposalBoxAlign({
  id,
  horizontal = 'left',
  vertical = 'center',
  innerMode = 'full',
  className = '',
  style,
  children,
}) {
  const { h, v } = flexClasses(horizontal, vertical);
  const innerClass = innerMode === 'shrink' ? styles.innerShrink : styles.innerFull;

  return (
    <div
      id={id}
      /* Marqueur stable : étiré (flex-grow) dans les colonnes de section pour
         que l'alignement vertical ait de la hauteur — cf. ProposalSection.module.css */
      data-box-align=""
      className={`${styles.align} ${styles[`h_${h}`]} ${styles[`v_${v}`]} ${className}`.trim()}
      style={style}
    >
      <div className={innerClass}>{children}</div>
    </div>
  );
}
